import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex h-fit min-w-fit flex-col xl:min-w-55',
    price: 'items-baseline',
    loyalty: ''
  },
  variants: {}
});
